import { observer } from "mobx-react";
import React from "react";
import { Text, Loader, Box } from "@mantine/core";

import { Cubby } from "../stores/Cubby";
import { TextWithInfo } from "./modals/textWithInfo";

const GenericEstimatedFee = observer(({ cubby }: { cubby: Cubby }) => {
  console.log(
    "value of cubby.sixConfirmationEstimateOrNull: ",
    cubby.sixConfirmationEstimateOrNull
  );
  return (
    <>
      <Box mt="md" mb="md">
        {cubby.sixConfirmationEstimateOrNull === null ? (
          <Text>
            fee estimate: <Loader size="sm" color="blue" />
          </Text>
        ) : (
          <Text size="md">
            {"fee estimate: " +
              cubby.sixConfirmationEstimateOrNull.fee.toLocaleString() +
              " satoshis"}
          </Text>
          // <TextWithInfo
          //   textSize="md"
          //   text={
          //
          //   }
          //   infoLink="https://docs.megalithic.me"
          //   infoCircleNudge={{ vertical: -2, horizontal: -6 }}
          // />
        )}
      </Box>
    </>
  );
});

export default GenericEstimatedFee;
